// extracted by mini-css-extract-plugin
export default {"loginPage":"LoginPage_loginPage__dj3Z-","inner":"LoginPage_inner__1RPO9","title":"LoginPage_title__LxJlg","loginWrapper":"LoginPage_loginWrapper__BIbzv"};